var dsox = dsox || {};
dsox.Animation = (function () {
    
    var fadeAndScroll = function ($) {
        var controller = new ScrollMagic.Controller();

        $('.js-fade').each(function(){
            var eachSection = this;

            new ScrollMagic.Scene({
                    triggerElement: eachSection,
                    triggerHook: "onEnter",
                    reverse: false
                })
                .setClassToggle(eachSection, "js-visible") 
                .addTo(controller);
        })
    }

    return {
        fadeAndScroll: fadeAndScroll
    }

}());

